import React from 'react';
import { Link } from 'react-router-dom';
import {
  SOCIAL_LINKS,
  SWIMBOOKER_APP_STORE_URL,
  SWIMBOOKER_GOOGLE_PLAY_URL,
} from '../../../../AppConstants';
import FooterTrustBox from './FooterTrustBox';
import swimbookerLogoWhite from '../../../../assets/images/Logos/swimbooker_logo_small_white.png';
import appStoreBadge from '../../assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
import googlePlayBadge from '../../assets/images/google-play-badge.png';
import { ReactComponent as FacebookIcon } from '../../assets/images/facebook.svg';
import { ReactComponent as InstagramIcon } from '../../assets/images/instagram.svg';
import { ReactComponent as XIcon } from '../../assets/images/x_logo.svg';
import { ReactComponent as YouTubeIcon } from '../../assets/images/youtube.svg';
import { ReactComponent as TikTokIcon } from '../../assets/images/tik-tok.svg';
import '../../assets/css/footer_brand.css';

const SOCIALS = [
  { label: 'Facebook', href: SOCIAL_LINKS.FACEBOOK, Icon: FacebookIcon },
  { label: 'Instagram', href: SOCIAL_LINKS.INSTAGRAM, Icon: InstagramIcon },
  { label: 'X', href: SOCIAL_LINKS.X, Icon: XIcon },
  { label: 'YouTube', href: SOCIAL_LINKS.YOUTUBE, Icon: YouTubeIcon },
  { label: 'TikTok', href: SOCIAL_LINKS.TIKTOK, Icon: TikTokIcon },
];

function FooterBrand() {
  return (
    <div className='sbf-brand display-flex-column'>
      <Link to='/' aria-label='swimbooker home' className='sbf-brand__logo'>
        <img src={swimbookerLogoWhite} alt='swimbooker' />
      </Link>

      <div className='display-flex-column gap-05r'>
        <p className='sbf-brand__description fs-15 gRegular'>
          Book day tickets, lakes and fishing holidays across the UK, Europe and
          Thailand.
        </p>
        <p className='sbf-brand__tagline fs-18 gBold white'>
          Less Hassle. More Fishing.
        </p>
      </div>

      <FooterTrustBox />

      <div className='sbf-brand__badges display-flex-column'>
        <a href={SWIMBOOKER_APP_STORE_URL} className='sbf-brand__badge br8'>
          <img src={appStoreBadge} alt='Download on the App Store' />
        </a>
        <a href={SWIMBOOKER_GOOGLE_PLAY_URL} className='sbf-brand__badge br8'>
          <img src={googlePlayBadge} alt='Get it on Google Play' />
        </a>
      </div>

      <ul
        className='sbf-socials flex-wrap gap-05r'
        aria-label='swimbooker on social media'
      >
        {SOCIALS.map(({ label, href, Icon }) => (
          <li key={label}>
            <a
              href={href}
              aria-label={label}
              target='_blank'
              rel='me noopener noreferrer'
              className='sbf-socials__link justify-center br50 fs-18'
            >
              <Icon width='1em' height='1em' fill='currentColor' aria-hidden />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default FooterBrand;
